export const pushToDataLayer = (eventPayload) => {
  if (typeof window === 'undefined' || !window.dataLayer || !Array.isArray(window.dataLayer)) {
    return;
  }

  if (!eventPayload || typeof eventPayload !== 'object') {
    return;
  }

  window.dataLayer.push(eventPayload);
};

